// extracted by mini-css-extract-plugin
module.exports = {"centeredText":"ColorSection_centeredText__BsGM8"};